import React from 'react';
import { useNotify, useMutation, Button, Datagrid, ArrayField, TextField, FunctionField} from 'react-admin';
import RejectIcon from '@material-ui/icons/WarningRounded';
import BlockedIcon from '@material-ui/icons/HighlightOff';
import AuditedIcon from '@material-ui/icons/CheckCircleOutline';
import AuditIcon from '@material-ui/icons/VerifiedUserOutlined';
import CheckCircle from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import WarningIcon from '@material-ui/icons/WarningRounded';
import Tooltip from '@material-ui/core/Tooltip';
import {InactiveButtonStyle, WarningButtonStyle, SuccessButtonStyle} from '../styles/common';
import { Box } from "@material-ui/core";

export const AUDIT_STATUS = [
  {id: 'unaudited', name: 'Unaudited'},
	{id: 'pending', name: 'Pending'},
	{id: 'approved', name: 'Approved'},
	{id: 'rejected', name: 'Rejected'}
  // {id: 'not found', name: 'Not Found'},
  // {id: 'audited', name: 'Audited'},
  // {id: 'unaudited', name: 'Unaudited'},
  // {id: 'unauditable', name: 'Unauditable'},
  // {id: 'is_adserver', name: 'Ad Server'}
];

export const AuditListStatus = ({record, ...props}) => {
  const show = [];
  if (!record) return null;
  record = record.domain_data || record;
  if (record && record.audit_status==='rejected') {
    const tooltip = <div style={{fontSize: 'larger', fontWeight: 'bold'}}>Domain was rejected by at least 1 Demand.</div>;
    show.push(<Button label='Warning' size="small" variant='contained' 
    disableElevation startIcon={<Tooltip title={tooltip} arrow leaveDelay="500"><WarningIcon /></Tooltip>} 
    style={{width: '120px', fontSize: '10px', color: 'white', backgroundColor: '#f2af18', borderRadius: '0%'}}></Button>);
  } else if (record && record.audit_status) {
    show.push(<Button disabled="true" label={`${record.audit_status} `} size="small" variant='contained' 
    disableElevation startIcon={<CheckCircle />} 
    style={{width: '120px', fontSize: '10px', color: 'white', borderRadius: '0%'}}></Button>);
  }
  return (
    show
  );
}
export const AuditButton = (props) => {
  // const id = props.record.code;
  const id =  (props.record && props.record.domain_id && props.record.domain_id) || (props.record && props.record.code);
  const notify = useNotify();
  const [crawl, { loading }] = useMutation({
      type: 'getOne',
      resource: 'domain_audit?domain=' + id + '&x=',
      payload: { }
  },
      {
          onSuccess: ({ data }) => {
              window.location.reload(false)
              notify('We have requested to audited this domain', 'info', {}, false);
          },
          onFailure: (error) => notify(`Domain audit error: ${error.message}`, 'warning'),
      }
  );

  return <Button label="Audit Domain (Appnexus)" onClick={crawl} disabled={loading} startIcon={<AuditIcon />} variant="contained" color="primary" />;
};
export const AuditButtonOld = (props) => {
  props = props.props;
  // const id = props.record.code;
  const id =  (props.record && props.record.domain && props.record.domain.code) || (props.record && props.record.code);
  const notify = useNotify();
  const [crawl, { loading }] = useMutation({
      type: 'getOne',
      resource: 'domain_audit?domain=' + id + '&x=',
      payload: { }
  },
      {
          onSuccess: ({ data }) => {
              window.location.reload(false)
              notify('We have requested to audited this domain', 'info', {}, false);
          },
          onFailure: (error) => notify(`Domain audit error: ${error.message}`, 'warning'),
      }
  );

  return <Button label="Audit Domain (Appnexus)" onClick={crawl} disabled={loading} startIcon={<AuditIcon />} variant="contained" color="primary" />;
};
export function AuditStatus({parent, ...props}) {
  if (parent && parent.bidder_audit_status && props.record.bidder_id) {
    const auditStatus = parent.bidder_audit_status['' + props.record.bidder_id];
    if (auditStatus && auditStatus.status && auditStatus.status === 'rejected') {
      return [<b style={{color: 'orangered'}}>{auditStatus.status.toUpperCase()}</b>,
        <div style={{whiteSpace: 'nowrap'}}>{auditStatus.message}</div>
      ];
    } else if (auditStatus && auditStatus.status && auditStatus.status === 'approved') {
      return <b style={{color: 'springgreen'}}>{auditStatus.status.toUpperCase()}</b>;
    } else if (auditStatus && auditStatus.status) {
      return <span style={{whiteSpace: 'nowrap'}}>{auditStatus.status.toUpperCase()}</span>;
    }
  }
  if (props.record.rejected) {
    return <b style={{color: 'orangered'}}>REJECTED</b>;
  }
  return ' ';
}
export function AuditStatusDetail (props) {
  return (
    <div>
    <div style={{fontSize: 'normal', marginBottom: '10px'}}>Audit Status</div>
    {(props.role === 'admin') && <AuditButton {...props}/>}
    <br/><br/><br/>
    <ArrayField source="bidder_audit_status_list" label="Bidder Status">
        <Datagrid style={{ width: '50%' }}>
            {(props.role === 'admin') &&
            <FunctionField label="Bidder" render={record => `${record.bidder_name || ''} (${record.bidder_id})`} style={{whiteSpace: 'nowrap'}}/>
            }
            {(props.role !== 'admin') &&
            <TextField label="Bidder" source="bidder_name" style={{whiteSpace: 'nowrap'}}/>
            }
            <BidderStatus label="Status" {...props} style={{whiteSpace: 'nowrap'}}/>
            <TextField source="message" label="Message" style={{whiteSpace: 'nowrap'}}/>
        </Datagrid>
    </ArrayField>
    <br/>
    <TextField source="last_crawl_appn" label="Last Audit Time (Appnexus)" />
    </div>
  );
}
export function BidderStatus(props) {
  if (props.record.status !== 'rejected') {
    return <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
      <Box sx={{marginTop: '5px'}} mr={{ xs: 0, sm: '1em' }}><CheckCircle style={{ color: 'springgreen' }} /></Box>
      <Box sx={{marginTop: '5px'}} mr={{ xs: 0, sm: '1em' }}>{props.record.status}</Box>
      </Box>;
    ;
  }
  return <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
  <Box sx={{marginTop: '5px'}} mr={{ xs: 0, sm: '1em' }}><HighlightOffIcon style={{ color: 'orangered' }} /></Box>
  <Box sx={{marginTop: '5px'}} mr={{ xs: 0, sm: '1em' }}>{props.record.status}</Box>
  </Box>;
}
// export function AuditStatusDetail(props) {
//   const ret = [];
//   const auditStatus = (props.record.domain && props.record.domain.appn_status) || props.record.appn_status;
//   ret.push(AuditStatusSummary(props));
//   ret.push(<br/>);
//   ret.push(<br/>);
//   ret.push(<AuditButton props={props}/>);
//   ret.push(<br/>);
//   if (auditStatus) {
//     delete auditStatus.audit_status;
//     delete auditStatus.id;
//     delete auditStatus.url;
//     delete auditStatus.content_category;
//     delete auditStatus.content_category_id;
//     for (const key of Object.keys(auditStatus)) {
//       const val = auditStatus[key];
//       if (typeof val === 'boolean') {
//         ret.push(<br/>);
//         ret.push(<div>{key}:   {val?'TRUE':'FALSE'}</div>);
//       } else if (val) {
//         ret.push(<br/>);
//         ret.push(<div>{key}:   {val}</div>);
//       }
//     }
//     return ret;
//   }
//   return ret;
// }
export function RejectedButton () {
  return <Button disabled="true" label='Audit Warning' size="small" variant='contained' disableElevation
  startIcon={<RejectIcon />} style={WarningButtonStyle}></Button>;
}
export function BlockedButton () {
  return <Button disabled="true" label='Domain Blocked' size="small" variant='contained' disableElevation
  startIcon={<BlockedIcon />} style={InactiveButtonStyle}></Button>;
}
function StatusButton (status) {
  return <Button disabled="true" label={status} variant='contained' disableElevation
  startIcon={<AuditedIcon />} style={SuccessButtonStyle}></Button>;
}
export function AuditStatusSummary(props) {
  const ret = [];
  const record = (props.record.domain && props.record.domain) || props.record;
  if (record) {
    let checked = false;
    if (record.audit_status) {
      if (record.audit_status === 'rejected' ) {
        ret.push(<div style={{fontSize: 'normal', marginBottom: '10px'}}>Audit Status</div>);
        ret.push(RejectedButton());
      }/* else {
        ret.push(StatusButton(auditStatus.audit_status));
      }*/
      checked = true;
    }
    // if (!checked) {
    //   if (auditStatus.found === true) {
    //     ret.push(<div>Domain Found</div>);
    //   } else if (auditStatus.found === false) {
    //     ret.push(<div>Domain NOT Found</div>);
    //   }
    // }
    return ret;
  }
  return <div style={{fontSize: 'small'}}>No Audit Yet</div>;
}